// import React, { useState, useEffect, useRef } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Cookies from "js-cookie";
// import { format, parseISO } from "date-fns";
// import { ChevronLeft, Check } from "lucide-react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./EventCreate.css";
// import { useNavigate } from "react-router-dom";

// const APPROVAL_RANGES = [
//   { id: "1", label: "5 Lakhs", value: "500000" },
//   { id: "2", label: "7 Lakhs", value: "700000" },
//   { id: "3", label: "10 Lakhs", value: "1000000" },
// ];

// const LOCATIONS = [
//   { id: "1", name: "Bangalore" },
//   { id: "2", name: "Mumbai" },
//   { id: "3", name: "Delhi" },
//   { id: "4", name: "Chennai" },
//   { id: "5", name: "Hyderabad" },
// ];

// const DURATIONS = [
//   { id: "1", label: "5 Mins", value: "5" },
//   { id: "2", label: "10 Mins", value: "10" },
//   { id: "3", label: "15 Mins", value: "15" },
//   { id: "4", label: "30 Mins", value: "30" },
//   { id: "5", label: "45 Mins", value: "45" },
//   { id: "6", label: "1 Hour", value: "60" },
// ];

// function TextDisplayCopy({ link }) {
//   const [text, setText] = useState(link);
//   const [isCopied, setIsCopied] = useState(false);
//   const textRef = useRef(null);

//   const handleCopy = () => {
//     navigator.clipboard.writeText(text).then(() => {
//       setIsCopied(true);
//       setTimeout(() => setIsCopied(false), 1500);
//     });
//   };

//   const styles = {
//     container: {
//       maxWidth: "800px",
//       margin: "0 auto",
//       display: "flex",
//       boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
//     },
//     textDisplay: {
//       flexGrow: 1,
//       padding: "12px",
//       backgroundColor: "white",
//       border: "1px solid #ccc",
//       borderRight: "none",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       textOverflow: "ellipsis",
//       color: "#333",
//     },
//     copyButton: {
//       width: "48px",
//       padding: "12px",
//       backgroundColor: isCopied ? "#22c55e" : "#ef4444",
//       color: "white",
//       border: "none",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "background-color 0.3s ease",
//     },
//     icon: {
//       width: "20px",
//       height: "20px",
//       animation: isCopied ? "pulse 1.5s ease" : "none",
//     },
//   };

//   return (
//     <>
//       <style>{`
//         @keyframes pulse {
//           0% { transform: scale(1); }
//           25% { transform: scale(1.2); }
//           50% { transform: scale(1); }
//           75% { transform: scale(1.1); }
//           100% { transform: scale(1); }
//         }
//       `}</style>
//       <div style={styles.container}>
//         <div ref={textRef} style={styles.textDisplay}>
//           {text}
//         </div>
//         <button
//           onClick={handleCopy}
//           style={styles.copyButton}
//           aria-label="Copy text"
//         >
//           {isCopied ? (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M5 13l4 4L19 7"
//               ></path>
//             </svg>
//           ) : (
//             <svg
//               style={styles.icon}
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
//               ></path>
//             </svg>
//           )}
//         </button>
//       </div>
//     </>
//   );
// }

// const WeeklyCalendar = ({ selectedDate, onDateSelect, availableSlots }) => {
//   const weekDays = Object.keys(availableSlots)
//     .sort((a, b) => new Date(a) - new Date(b))
//     .map((date) => parseISO(date));

//   return (
//     <div
//       className="d-flex gap-2"
//       style={{ overflowX: "auto", maxWidth: "100%" }}
//     >
//       {weekDays.map((date) => {
//         const dateKey = format(date, "yyyy-MM-dd");
//         const hasSlots = availableSlots[dateKey]?.length > 0;
//         const carCount = availableSlots[dateKey]?.[0]?.carCountBelow1176 || 0;

//         return (
//           <button
//             key={dateKey}
//             onClick={() => hasSlots && onDateSelect(date)}
//             disabled={!hasSlots}
//             className={`p-4 text-black ${
//               selectedDate?.toDateString() === date.toDateString()
//                 ? "bg-danger text-white"
//                 : "bg-white hover:bg-light"
//             }`}
//             style={
//               hasSlots
//                 ? { border: "2px solid #ee373b", borderRadius: "10px" }
//                 : { cursor: "not-allowed", opacity: 0.5, borderRadius: "10px" }
//             }
//           >
//             <div className="text-sm">{format(date, "EEE")}</div>
//             <div className="text-lg font-semibold">{format(date, "d")}</div>
//             <div className="text-sm">Car Count: {carCount}</div>
//           </button>
//         );
//       })}
//     </div>
//   );
// };

// const TimeSlots = ({ timeSlots, onTimeSlotSelect }) => {
//   return (
//     <div className="d-flex flex-wrap gap-2 mt-6 mx-lg-10">
//       {timeSlots.map((slot, index) => (
//         <button
//           key={slot.time}
//           onClick={() => onTimeSlotSelect(index)}
//           className={`p-3 transition text-black ${
//             slot.selected ? "bg-danger text-white" : "bg-white hover:bg-light"
//           }`}
//           style={{ border: "2px solid #ee373b" }}
//         >
//           {slot.time}
//         </button>
//       ))}
//     </div>
//   );
// };

// const PeopleTable = ({ people, onPersonSelect }) => {
//   return (
//     <div
//       style={{
//         height: "40vh",
//         overflowY: "auto",
//         display: "block",
//         scrollbarColor: "#ee373b #ffffff",
//         scrollbarWidth: "thin",
//       }}
//     >
//       <table className="table table-hover" style={{ width: "100%" }}>
//         <thead className="bg-light">
//           <tr style={{ position: "sticky", top: 0, background: "white" }}>
//             <th
//               style={{
//                 textAlign: "left",
//                 textTransform: "uppercase",
//                 width: "25%",
//               }}
//             >
//               Name
//             </th>
//             <th
//               style={{
//                 textAlign: "left",
//                 textTransform: "uppercase",
//                 width: "25%",
//               }}
//             >
//               Number
//             </th>
//             <th
//               style={{
//                 textAlign: "left",
//                 textTransform: "uppercase",
//                 width: "35%",
//               }}
//             >
//               Address
//             </th>
//             <th
//               style={{
//                 textAlign: "left",
//                 textTransform: "uppercase",
//                 width: "15%",
//               }}
//             >
//               Select
//             </th>
//           </tr>
//         </thead>
//         <tbody style={{ overflowY: "auto", height: "calc(100% - 40px)" }}>
//           {people.map((person) => (
//             <tr key={person.id} style={{ width: "100%" }}>
//               <td style={{ width: "25%" }}>{person.name}</td>
//               <td style={{ width: "25%" }}>{person.primaryPhone}</td>
//               <td style={{ width: "35%" }}>{person.contactAddress}</td>
//               <td style={{ width: "15%" }}>
//                 <input
//                   type="checkbox"
//                   checked={person.selected}
//                   onChange={() => onPersonSelect(person.lenderBuyerId)}
//                 />
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// function App() {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     selectedDate: null,
//     selectedTimeSlots: null,
//     approvalLimit: "",
//     location: "",
//     selectedPeople: [],
//     duration: "",
//   });
//   const [isComplete, setIsComplete] = useState(false);
//   const [availableSlots, setAvailableSlots] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [communityNo, setCommunityNo] = useState(null);
//   const [eventTitle, setEventTitle] = useState(null);
//   const [location, setLocation] = useState(null);
//   const [carCount, setCarCount] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [link, setLink] = useState("");

//   var cm = communityNo;
//   useEffect(() => {
//     const communityNumber = parseInt(Cookies.get("adminCommunityNO"), 10);
//     console.log(communityNumber);
//     setCommunityNo(communityNumber);
//     cm = communityNumber;
//     const lenderInfoRaw = Cookies.get("adminLenderInfo") || "";
//     const [firstName = "", lastName = ""] = lenderInfoRaw.split("_");
//     const lenderInfo = `${firstName} ${lastName}`.trim();
//     const loc = Cookies.get("adminLocation") || "";
//     setLocation(loc);
//     const eventTitles = `${lenderInfo} ${location}`.trim();
//     setEventTitle(eventTitles);
//   }, [currentStep]);

//   useEffect(() => {
//     const loc = Cookies.get("adminLocation");
//     // Fetch available time slots
//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/showAvailableSlotsForNextWeek?location=${loc}`,
//       {
//         credentials: "include",
//         headers: {
//           "X-Full-URL": window.location.href, // Optional: full URL
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         setAvailableSlots(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching available slots:", error);
//       });
//   }, []);

//   useEffect(() => {
//     // Fetch users based on approval limit
//     if (formData.approvalLimit) {
//       const maxLimit = formData.approvalLimit;
//       fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/buyers/limit?communityNo=${cm}&preapprovdlimitvalue=${maxLimit}`,
//         {
//           credentials: "include",
//           headers: {
//             "X-Full-URL": window.location.href, // Optional: full URL
//           },
//         }
//       )
//         .then((response) => response.json())
//         .then((data) => {
//           // Add selected property to each user
//           const usersWithSelected = data.map((person) => ({
//             ...person,
//             selected: false,
//           }));
//           setUsers(usersWithSelected);
//           setCurrentPage(1); // Reset to first page on new data
//         })
//         .catch((error) => {
//           console.error("Error fetching users:", error);
//         });
//     }
//   }, [formData.approvalLimit]);

//   const handleDateSelect = (date) => {
//     const dateKey = format(date, "yyyy-MM-dd");
//     const slotsForDate = availableSlots[dateKey] || [];

//     // Map the available slots to the correct format
//     const formattedTimeSlots = slotsForDate.map((slot) => ({
//       time: slot.availebleSlot,
//       selected: false,
//       id: slot.slotId,
//     }));

//     setFormData((prev) => ({
//       ...prev,
//       selectedDate: date,
//       selectedTimeSlots: formattedTimeSlots,
//     }));

//     // Set car count based on the selected date
//     const carCount = slotsForDate[0]?.carCountBelow1176 || 0;
//     setCarCount(carCount);
//     console.log("## form data", formData);
//   };

//   const handleTimeSlotSelect = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       selectedTimeSlots: prev.selectedTimeSlots.map((slot, i) => ({
//         ...slot,
//         selected: i === index,
//       })),
//     }));
//     setCurrentStep(2);
//     console.log("## form data", formData);
//   };

//   const handleApprovalLimitChange = (e) => {
//     const selectedLimit = e.target.value;
//     setFormData((prev) => ({ ...prev, approvalLimit: selectedLimit }));

//     console.log("## form data", formData);
//     // Set car count based on the selected approval limit
//     const dateKey = format(formData.selectedDate, "yyyy-MM-dd");
//     const slotsForDate = availableSlots[dateKey] || [];
//     let carCount = 0;

//     if (selectedLimit === "500000") {
//       carCount = slotsForDate[0]?.carCountBelow588 || 0;
//     } else if (selectedLimit === "700000") {
//       carCount = slotsForDate[0]?.carCountBelow823 || 0;
//     } else if (selectedLimit === "1000000") {
//       carCount = slotsForDate[0]?.carCountBelow1176 || 0;
//     }

//     setCarCount(carCount);
//   };

//   const handleLocationChange = (e) => {
//     setFormData((prev) => ({ ...prev, location: e.target.value }));
//   };

//   const handleDurationChange = (e) => {
//     setFormData((prev) => ({ ...prev, duration: e.target.value }));
//   };

//   const handlePersonSelect = (id) => {
//     setUsers((prevUsers) =>
//       prevUsers.map((person) =>
//         person.lenderBuyerId === id
//           ? { ...person, selected: !person.selected }
//           : person
//       )
//     );
//   };

//   const handleNext = () => {
//     if (currentStep < 4) {
//       setCurrentStep((prev) => prev + 1);
//     } else {
//       setIsComplete(true);
//     }
//   };

//   const handleBack = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleCreateEvent = () => {
//     const selectedTimeSlot = formData.selectedTimeSlots.find(
//       (slot) => slot.selected
//     );
//     const selectedUsers = users.filter((person) => person.selected);

//     // Parse start date and time
//     const startDate = new Date(formData.selectedDate);
//     const [hours, minutes] = selectedTimeSlot.time.split(":").map(Number);

//     // Set start time
//     startDate.setHours(hours, minutes, 0, 0);

//     // Add duration to get end time
//     const endDate = new Date(startDate);
//     endDate.setMinutes(endDate.getMinutes() + parseInt(formData.duration, 10));

//     // Format back to 'yyyy-MM-dd HH:mm:ss'
//     const formatDateTime = (date) => {
//       const pad = (n) => n.toString().padStart(2, "0");

//       const year = date.getFullYear();
//       const month = pad(date.getMonth() + 1); // Months are 0-indexed
//       const day = pad(date.getDate());
//       const hours = pad(date.getHours());
//       const minutes = pad(date.getMinutes());
//       const seconds = pad(date.getSeconds());

//       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     };

//     const eventData = {
//       event: {
//         eventTitle: eventTitle,
//         location: location,
//         startDateAndTime: formatDateTime(startDate),
//         endDateAndTime: formatDateTime(endDate),
//         userApprovedLimit: formData.approvalLimit,
//         communityNo: communityNo,
//         auctionSlotId:
//           formData.selectedTimeSlots.find((slot) => slot.selected)?.id || null,
//         duration: formData.duration,
//       },
//       userIds: selectedUsers.map((user) => user.lenderBuyerId),
//     };

//     fetch(
//       `${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/lender-upload`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-Full-URL": window.location.href, // Optional: full URL
//         },
//         body: JSON.stringify(eventData),
//         credentials: "include",
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.message.includes("Event created successfully")) {
//           if (data.link) {
//             console.log("private link ====>", data.link);
//             setLink(data.link);
//           }
//           setIsComplete(true);
//         } else {
//           console.error("Error creating event:", data);
//         }
//       })
//       .catch((error) => {
//         console.error("Error creating event:", error);
//       });
//   };

//   const slideVariants = {
//     enter: (direction) => ({
//       x: direction > 0 ? 1000 : -1000,
//       opacity: 0,
//     }),
//     center: {
//       zIndex: 1,
//       x: 0,
//       opacity: 1,
//     },
//     exit: (direction) => ({
//       zIndex: 0,
//       x: direction < 0 ? 1000 : -1000,
//       opacity: 0,
//     }),
//   };
//   const nav = useNavigate();

//   const renderStep = () => {
//     return (
//       <div>
//         {currentStep === 1 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select Date & Time
//             </h2>
//             <div className="d-flex flex-column gap-5 justify-content-center align-items-center">
//               <WeeklyCalendar
//                 selectedDate={formData.selectedDate}
//                 onDateSelect={handleDateSelect}
//                 availableSlots={availableSlots}
//               />
//               {formData.selectedDate && (
//                 <TimeSlots
//                   timeSlots={formData.selectedTimeSlots}
//                   onTimeSlotSelect={handleTimeSlotSelect}
//                 />
//               )}
//               {carCount > 0 && (
//                 <div className="mt-4">
//                   <strong>Car Count for the day: {carCount}</strong>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {currentStep === 2 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Set Approval Limit & Duration
//             </h2>
//             <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
//               <div className="mb-3">
//                 <label htmlFor="approvalLimit" className="form-label">
//                   Approval Limit
//                 </label>
//                 <select
//                   id="approvalLimit"
//                   value={formData.approvalLimit}
//                   style={{ maxWidth: "300px" }}
//                   onChange={handleApprovalLimitChange}
//                   className="form-select"
//                 >
//                   <option>Select Pre-Approval Limit</option>
//                   {APPROVAL_RANGES.map((range) => (
//                     <option key={range.id} value={range.value}>
//                       {range.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="mb-3">
//                 <label htmlFor="duration" className="form-label">
//                   Duration of Event
//                 </label>
//                 <select
//                   id="duration"
//                   value={formData.duration}
//                   onChange={handleDurationChange}
//                   style={{ maxWidth: "300px" }}
//                   className="form-select"
//                 >
//                   <option>Select Duration</option>
//                   {DURATIONS.map((duration) => (
//                     <option key={duration.id} value={duration.value}>
//                       {duration.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               {carCount > 0 && (
//                 <div className="mt-4">
//                   <strong>Car Count: {carCount}</strong>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {currentStep === 3 && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Select People
//             </h2>
//             <PeopleTable
//               people={users}
//               onPersonSelect={handlePersonSelect}
//               currentPage={currentPage}
//               totalPages={Math.ceil(users.length / 5)}
//               onPageChange={setCurrentPage}
//             />
//           </div>
//         )}

//         {currentStep === 4 && !isComplete && (
//           <div>
//             <h2
//               className="h2 mb-6"
//               style={{ color: "#ee373b", margin: "15px 0px" }}
//             >
//               Review & Create Event
//             </h2>
//             <div className="space-y-4">
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Date: {formData.selectedDate?.toLocaleDateString()}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected Time Slots:{" "}
//                 {formData.selectedTimeSlots
//                   .filter((slot) => slot.selected)
//                   .map((slot) => slot.time)
//                   .join(", ")}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Approval Limit:{" "}
//                 {
//                   APPROVAL_RANGES.find(
//                     (range) => range.value === formData.approvalLimit
//                   )?.label
//                 }
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Location: {formData.location}
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Duration:{" "}
//                 {
//                   DURATIONS.find(
//                     (duration) => duration.value === formData.duration
//                   )?.label
//                 }
//               </p>
//               <p style={{ fontSize: "16px", fontWeight: "bold" }}>
//                 Selected People:{" "}
//                 {users
//                   .filter((person) => person.selected)
//                   .map((person) => person.name)
//                   .join(", ")}
//               </p>
//             </div>
//           </div>
//         )}

//         {isComplete && (
//           <div className="text-center mt-5">
//             <div
//               className="d-inline-flex justify-content-center align-items-center bg-success-light mb-4"
//               style={{ width: "4rem", height: "4rem", borderRadius: "4rem" }}
//             >
//               <Check className="w-8 h-8 text-success" />
//             </div>
//             <h2 className="h2 mb-2">Event Created Successfully!</h2>
//             <p className="text-muted">
//               Your event has been scheduled and invitations will be sent to the
//               selected participants.
//             </p>
//             {link.length > 0 ? (
//               <TextDisplayCopy link={link} />
//             ) : (
//               <button
//                 onClick={() => nav("/lenderEvent")}
//                 className="btn btn-primary mt-3"
//               >
//                 Manage Events
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-vh-100  align-items-center p-4">
//       <div
//         className="w-100 max-w-4xl bg-white overflow-hidden position-relative"
//         style={{
//           minHeight: "75vh",
//           maxHeight: "75vh",
//           borderRadius: "20px",
//           border: "2px solid red",
//         }}
//       >
//         <div style={{ backgroundColor: "#ee373b", padding: "5px" }}>
//           <h2 style={{ color: "white", fontWeight: "bold" }}>Create Event</h2>
//         </div>
//         <div className="h-100 px-3 d-flex flex-column position-relative">
//           {renderStep()}
//           {!isComplete && (
//             <div
//               className="d-flex gap-2 justify-content-end p-3 mt-auto position-fixed"
//               style={{
//                 backgroundColor: "rgba(0,0,0,0)",
//                 bottom: "10vh",
//                 right: "3vw",
//               }}
//             >
//               {currentStep > 1 && (
//                 <button onClick={handleBack} className="btn btn-secondary">
//                   Back
//                 </button>
//               )}
//               <button
//                 onClick={() => {
//                   currentStep === 4 ? handleCreateEvent() : handleNext();
//                 }}
//                 className="btn btn-danger"
//               >
//                 {currentStep === 4 ? "Create Event" : "Next"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;

import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Cookies from 'js-cookie';
import { format, parseISO } from 'date-fns';
import { ChevronLeft, Check } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './EventCreate.css';
import { useNavigate } from 'react-router-dom';

const APPROVAL_RANGES = [
  { id: '1', label: '5 Lakhs', value: '500000' },
  { id: '2', label: '7 Lakhs', value: '700000' },
  { id: '3', label: '10 Lakhs', value: '1000000' },
];

const LOCATIONS = [
  { id: '1', name: 'Bangalore' },
  { id: '2', name: 'Mumbai' },
  { id: '3', name: 'Delhi' },
  { id: '4', name: 'Chennai' },
  { id: '5', name: 'Hyderabad' },
];

const DURATIONS = [
  { id: '1', label: '5 Mins', value: '5' },
  { id: '2', label: '10 Mins', value: '10' },
  { id: '3', label: '15 Mins', value: '15' },
  { id: '4', label: '30 Mins', value: '30' },
  { id: '5', label: '45 Mins', value: '45' },
  { id: '6', label: '1 Hour', value: '60' },
];

function TextDisplayCopy({ link }) {
  const [text, setText] = useState(link);
  const [isCopied, setIsCopied] = useState(false);
  const textRef = useRef(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    });
  };

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      display: 'flex',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    },
    textDisplay: {
      flexGrow: 1,
      padding: '12px',
      backgroundColor: 'white',
      border: '1px solid #ccc',
      borderRight: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#333'
    },
    copyButton: {
      width: '48px',
      padding: '12px',
      backgroundColor: isCopied ? '#22c55e' : '#ef4444',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.3s ease'
    },
    icon: {
      width: '20px',
      height: '20px',
      animation: isCopied ? 'pulse 1.5s ease' : 'none'
    }
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          25% { transform: scale(1.2); }
          50% { transform: scale(1); }
          75% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
      <div style={styles.container}>
        <div ref={textRef} style={styles.textDisplay}>{text}</div>
        <button onClick={handleCopy} style={styles.copyButton} aria-label="Copy text">
          {isCopied ? (
            <svg style={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          ) : (
            <svg style={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
            </svg>
          )}
        </button>
      </div>
    </>
  );
}

const WeeklyCalendar = ({ selectedDate, onDateSelect, availableSlots }) => {
  const weekDays = Object.keys(availableSlots)
    .sort((a, b) => new Date(a) - new Date(b))
    .map((date) => parseISO(date));

  return (
    <div className="d-flex gap-2" style={{ overflowX: 'auto', maxWidth: '100%' }}>
      {weekDays.map((date) => {
        const dateKey = format(date, 'yyyy-MM-dd');
        const hasSlots = availableSlots[dateKey]?.length > 0;
        const carCount = availableSlots[dateKey]?.[0]?.carCountBelow1176 || 0;

        return (
          <button
            key={dateKey}
            onClick={() => hasSlots && onDateSelect(date)}
            disabled={!hasSlots}
            className={`p-4 text-black ${
              selectedDate?.toDateString() === date.toDateString()
                ? 'bg-danger text-white'
                : 'bg-white hover:bg-light'
            }`}
            style={hasSlots ? { border: "2px solid #ee373b", borderRadius: "10px" } : { cursor: 'not-allowed', opacity: 0.5, borderRadius: "10px" }}
          >
            <div className="text-sm">{format(date, 'EEE')}</div>
            <div className="text-lg font-semibold">{format(date, 'd')}</div>
            <div className="text-sm">Car Count: 9</div>
          </button>
        );
      })}
    </div>
  );
};

const TimeSlots = ({ timeSlots, onTimeSlotSelect }) => {
  return (
    <div className="d-flex flex-wrap gap-2 mt-6 mx-lg-10" style={{overflowY:"auto"}}>
      {timeSlots.map((slot, index) => (
        <button
          key={slot.time}
          onClick={() => onTimeSlotSelect(index)}
          className={`p-3 transition text-black ${
            slot.selected ? 'bg-danger text-white' : 'bg-white hover:bg-light'
          }`}
          style={{ border: "2px solid #ee373b" }}
        >
          {slot.time}
        </button>
      ))}
    </div>
  );
};

const PeopleTable = ({ people, onPersonSelect }) => {
  return (
    <div style={{ height: '40vh', overflowY: 'auto', display: 'block', scrollbarColor: "#ee373b #ffffff", scrollbarWidth: "thin" }}>
      <table className="table table-hover" style={{ width: '100%' }}>
        <thead className="bg-light">
          <tr style={{ position: 'sticky', top: 0, background: 'white' }}>
            <th style={{ textAlign: 'left', textTransform: 'uppercase', width: '25%' }}>Name</th>
            <th style={{ textAlign: 'left', textTransform: 'uppercase', width: '25%' }}>Number</th>
            <th style={{ textAlign: 'left', textTransform: 'uppercase', width: '35%' }}>Address</th>
            <th style={{ textAlign: 'left', textTransform: 'uppercase', width: '15%' }}>Select</th>
          </tr>
        </thead>
        <tbody style={{ overflowY: 'auto', height: 'calc(100% - 40px)' }}>
          {people.map((person) => (
            <tr key={person.id} style={{ width: '100%' }}>
              <td style={{ width: '25%' }}>{person.name}</td>
              <td style={{ width: '25%' }}>{person.primaryPhone}</td>
              <td style={{ width: '35%' }}>{person.contactAddress}</td>
              <td style={{ width: '15%' }}>
                <input
                  type="checkbox"
                  checked={person.selected}
                  onChange={() => onPersonSelect(person.lenderBuyerId)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    selectedDate: null,
    selectedTimeSlots: null,
    approvalLimit: "",
    location: "",
    selectedPeople: [],
    duration: "",
  });
  const [isComplete, setIsComplete] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [users, setUsers] = useState([]);
  const [communityNo, setCommunityNo] = useState(null);
  const [eventTitle, setEventTitle] = useState(null);
  const [location, setLocation] = useState(null);
  const [carCount, setCarCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [link, setLink] = useState("");
  const [isStepValid, setIsStepValid] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const communityNumber = parseInt(Cookies.get('adminCommunityNO'), 10);
    setCommunityNo(communityNumber);
    const lenderInfoRaw = Cookies.get('adminLenderInfo') || '';
    const [firstName = '', lastName = ''] = lenderInfoRaw.split('_');
    const lenderInfo = `${firstName} ${lastName}`.trim();
    const loc = Cookies.get('adminLocation') || '';
    setLocation(loc);
    const eventTitles = `${lenderInfo} ${loc}`.trim();
    setEventTitle(eventTitles);
  }, []);

  useEffect(() => {
    const loc = Cookies.get('adminLocation');
    fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/showAvailableSlotsForNextWeek?location=${loc}`, {
      credentials: 'include',
      headers: {
        "X-Full-URL": window.location.href,
      }
    })
      .then((response) => response.json())
      .then((data) => {
        setAvailableSlots(data);
      })
      .catch((error) => {
        console.error('Error fetching available slots:', error);
      });
  }, []);

  useEffect(() => {
    if (formData.approvalLimit) {
      const maxLimit = formData.approvalLimit;
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/buyers/limit?communityNo=${communityNo}&preapprovdlimitvalue=${maxLimit}`, {
        credentials: 'include',
        headers: {
          "X-Full-URL": window.location.href,
        }
      })
        .then((response) => response.json())
        .then((data) => {
          const usersWithSelected = data.map((person) => ({
            ...person,
            selected: false,
          }));
          setUsers(usersWithSelected);
          setCurrentPage(1);
        })
        .catch((error) => {
          console.error('Error fetching users:', error);
        });
    }
  }, [formData.approvalLimit, communityNo]);

  useEffect(() => {
    if (currentStep === 1) {
      const isValid = formData.selectedDate && formData.selectedTimeSlots?.some(slot => slot.selected);
      setIsStepValid(isValid);
    } else if (currentStep === 2) {
      const isValid = formData.approvalLimit && formData.duration;
      setIsStepValid(isValid);
    } else if (currentStep === 3) {
      const isValid = users.some(person => person.selected);
      setIsStepValid(isValid);
    } else if (currentStep === 4) {
      setIsStepValid(true);
    }
  }, [formData, users, currentStep]);

  const handleDateSelect = (date) => {
    const dateKey = format(date, 'yyyy-MM-dd');
    const slotsForDate = availableSlots[dateKey] || [];
    const formattedTimeSlots = slotsForDate.map((slot) => ({
      time: slot.availebleSlot,
      selected: false,
      id: slot.slotId,
    }));

    setFormData((prev) => ({
      ...prev,
      selectedDate: date,
      selectedTimeSlots: formattedTimeSlots,
    }));

    const carCount = slotsForDate[0]?.carCountBelow1176 || 0;
    setCarCount(carCount);
  };

  const handleTimeSlotSelect = (index) => {
    setFormData((prev) => ({
      ...prev,
      selectedTimeSlots: prev.selectedTimeSlots.map((slot, i) => ({
        ...slot,
        selected: i === index,
      })),
    }));
    setCurrentStep(2);
  };

  const handleApprovalLimitChange = (e) => {
    const selectedLimit = e.target.value;
    setFormData((prev) => ({ ...prev, approvalLimit: selectedLimit }));

    const dateKey = format(formData.selectedDate, 'yyyy-MM-dd');
    const slotsForDate = availableSlots[dateKey] || [];
    let carCount = 0;

    if (selectedLimit === '500000') {
      carCount = slotsForDate[0]?.carCountBelow588 || 0;
    } else if (selectedLimit === '700000') {
      carCount = slotsForDate[0]?.carCountBelow823 || 0;
    } else if (selectedLimit === '1000000') {
      carCount = slotsForDate[0]?.carCountBelow1176 || 0;
    }

    setCarCount(carCount);
  };

  const handleLocationChange = (e) => {
    setFormData((prev) => ({ ...prev, location: e.target.value }));
  };

  const handleDurationChange = (e) => {
    setFormData((prev) => ({ ...prev, duration: e.target.value }));
  };

  const handlePersonSelect = (id) => {
    setUsers((prevUsers) =>
      prevUsers.map((person) =>
        person.lenderBuyerId === id ? { ...person, selected: !person.selected } : person
      )
    );
  };

  const handleNext = () => {
    if (currentStep < 4) {
      setCurrentStep((prev) => prev + 1);
    } else {
      setIsComplete(true);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleCreateEvent = () => {
    const selectedTimeSlot = formData.selectedTimeSlots.find((slot) => slot.selected);
    const selectedUsers = users.filter((person) => person.selected);

    const startDate = new Date(formData.selectedDate);
    const [hours, minutes] = selectedTimeSlot.time.split(':').map(Number);
    startDate.setHours(hours, minutes, 0, 0);

    const endDate = new Date(startDate);
    endDate.setMinutes(endDate.getMinutes() + parseInt(formData.duration, 10));

    const formatDateTime = (date) => {
      const pad = (n) => n.toString().padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const eventData = {
      event: {
        eventTitle: eventTitle,
        location: location,
        startDateAndTime: formatDateTime(startDate),
        endDateAndTime: formatDateTime(endDate),
        userApprovedLimit: formData.approvalLimit,
        communityNo: communityNo,
        auctionSlotId: formData.selectedTimeSlots.find((slot) => slot.selected)?.id || null,
        duration: formData.duration,
      },
      userIds: selectedUsers.map((user) => user.lenderBuyerId),
    };

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/lender/lender-events/lender-upload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-Full-URL": window.location.href,
      },
      body: JSON.stringify(eventData),
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message.includes('Event created successfully')) {
          if (data.link) {
            setLink(data.link);
          }
          setIsComplete(true);
        } else {
          console.error('Error creating event:', data);
        }
      })
      .catch((error) => {
        console.error('Error creating event:', error);
      });
  };

  const renderStep = () => {
    return (
      <div>
        {currentStep === 1 && (
          <div>
            <h2 className="h2 mb-6" style={{ color: "#ee373b", margin: "15px 0px" }}>Select Date & Time</h2>
            <div className="d-flex flex-column gap-5 justify-content-center align-items-center">
              <WeeklyCalendar
                selectedDate={formData.selectedDate}
                onDateSelect={handleDateSelect}
                availableSlots={availableSlots}
              />
              {formData.selectedDate && (
                <TimeSlots
                  timeSlots={formData.selectedTimeSlots}
                  onTimeSlotSelect={handleTimeSlotSelect}
                />
              )}
              {carCount > 0 && (
                <div className="mt-4">
                  {/* <strong>Car Count for the day: {carCount}</strong> */}
                </div>
              )}
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <h2 className="h2 mb-6" style={{ color: "#ee373b", margin: "15px 0px" }}>Set Approval Limit & Duration</h2>
            <div className="space-y-6 mt-2 d-flex flex-column justify-content-center">
              <div className="mb-3">
                <label htmlFor="approvalLimit" className="form-label">
                  Approval Limit
                </label>
                <select
                  id="approvalLimit"
                  value={formData.approvalLimit}
                  style={{ maxWidth: "300px" }}
                  onChange={handleApprovalLimitChange}
                  className="form-select"
                >
                  <option value="">Select Pre-Approval Limit</option>
                  {APPROVAL_RANGES.map((range) => (
                    <option key={range.id} value={range.value}>
                      {range.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="duration" className="form-label">
                  Duration of Event
                </label>
                <select
                  id="duration"
                  value={formData.duration}
                  onChange={handleDurationChange}
                  style={{ maxWidth: "300px" }}
                  className="form-select"
                >
                  <option value="">Select Duration</option>
                  {DURATIONS.map((duration) => (
                    <option key={duration.id} value={duration.value}>
                      {duration.label}
                    </option>
                  ))}
                </select>
              </div>
              {carCount > 0 && (
                <div className="mt-4">
                  <strong>Car Count: {carCount}</strong>
                </div>
              )}
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div>
            <h2 className="h2 mb-6" style={{ color: "#ee373b", margin: "15px 0px" }}>Select People</h2>
            <PeopleTable
              people={users}
              onPersonSelect={handlePersonSelect}
            />
          </div>
        )}

        {currentStep === 4 && !isComplete && (
          <div>
            <h2 className="h2 mb-6" style={{ color: "#ee373b", margin: "15px 0px" }}>Review & Create Event</h2>
            <div className="space-y-4">
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Date: {formData.selectedDate?.toLocaleDateString()}</p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Selected Time Slots: {formData.selectedTimeSlots.filter((slot) => slot.selected).map((slot) => slot.time).join(', ')}</p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Approval Limit: {APPROVAL_RANGES.find((range) => range.value === formData.approvalLimit)?.label}</p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Location: {formData.location}</p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Duration: {DURATIONS.find((duration) => duration.value === formData.duration)?.label}</p>
              <p style={{ fontSize: "16px", fontWeight: "bold" }}>Selected People: {users.filter((person) => person.selected).map((person) => person.name).join(', ')}</p>
            </div>
          </div>
        )}

        {isComplete && (
          <div className="text-center mt-5">
            <div className="d-inline-flex justify-content-center align-items-center bg-white mb-4" style={{ width: "4rem", height: "4rem", border:"1px solid #ee373b" , borderRadius: "4rem" }}>
              <Check className="w-8 h-8 text-danger bg-white" />
            </div>
            <h2 className="h2 mb-2">Event Created Successfully!</h2>
            <p className="text-muted">Your event has been scheduled and invitations will be sent to the selected participants.</p>
            {link.length > 0 ? <TextDisplayCopy link={link} /> : <button onClick={() => navigate("/lenderEvent")} className="btn btn-danger mt-3">
              Manage Events
            </button>}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-vh-100 align-items-center p-4">
      <div className="w-100 max-w-4xl bg-white overflow-hidden position-relative" style={{ minHeight: '75vh', maxHeight: '75vh', borderRadius: "20px", border: "2px solid red" }}>
        <div style={{ backgroundColor: "#ee373b", padding: "5px" }}>
          <h2 style={{ color: "white", fontWeight: "bold" }}>Create Event</h2>
        </div>
        <div className="h-100 px-3 d-flex flex-column position-relative">
          {renderStep()}
          {!isComplete && (
            <div
              className="d-flex gap-2 justify-content-end p-3 mt-auto position-fixed"
              style={{ backgroundColor: "rgba(0,0,0,0)", bottom: "10vh", right: "3vw" }}
            >
              {currentStep > 1 && (
                <button onClick={handleBack} className="btn btn-outline-danger">
                  Back
                </button>
              )}
              <button
                onClick={() => {
                  currentStep === 4 ? handleCreateEvent() : handleNext();
                }}
                className="btn btn-danger"
                disabled={!isStepValid}
              >
                {currentStep === 4 ? "Create Event" : "Next"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;